import { GetDisplayableFeedbackQuestionnaireResponse as GetDisplayableFeedbackQuestionnaireResponseCore } from '@amzn/coral_com-amazon-trans-feedback-tcfa-model-v-1';
import { modelRegistrySingleton } from '@amzn/ihm-js-coral-client';

/**
 * Extended class to override the de-serialization behavior (fromJson)
 * In coral expected format of the __type value is different between RPC calls and HTTP binding calls.
 * for more [info](https://issues.amazon.com/SFOFFICE-362).
 */
class GetDisplayableFeedbackQuestionnaireResponse extends GetDisplayableFeedbackQuestionnaireResponseCore {
  static fromJson(data) {
    return GetDisplayableFeedbackQuestionnaireResponse.clone(data);
  }
}

// Register concrete types for serialization
modelRegistrySingleton.registerType(
  GetDisplayableFeedbackQuestionnaireResponse
);
export default GetDisplayableFeedbackQuestionnaireResponse;
